import { dateShortIn } from 'Data/format.js'

import { parse, parseISO, isValid } from 'date-fns'

function toDate(date) {
  if (date === undefined || date === null) {
    return date
  }

  let d

  if (date instanceof Date) {
    d = date
  } else if (typeof date === 'number') {
    d = new Date(date)
  } else if (typeof date === 'string' && date.length) {
    d = date.includes('/')
      ? parse(date, 'MM/dd/yyyy', new Date())
      : parseISO(date)
  } else {
    return null
  }

  if (!isValid(d)) {
    return null
  }

  return d
}

export function useGetText(props) {
  let { from, to } = props.daterange ?? {}
  if (from) {
    let result = []
    let dateFrom = toDate(from)
    if (dateFrom instanceof Date && !isNaN(dateFrom.getTime())) {
      result.push(dateShortIn(dateFrom))
    }

    let dateTo = toDate(to)
    if (dateTo instanceof Date && !isNaN(dateTo.getTime())) {
      result.push(dateShortIn(dateTo))
    } else {
      result.push('')
    }

    return result.join(' - ')
  }

  return 'Select a date range'
}
